import type { TPlayer } from 'video.js'
import type { TextTrackCustomSettings } from './text-track-custom-settings'

/**
 * Remove classes matching a regex pattern from player element
 */
const removeClassesByRegex = (player: TPlayer, regex: RegExp) => {
  const element = player.el()
  if (!element) return

  const currentClasses = element.className
  const classesToRemove = (currentClasses.match(regex) || []).join(' ')

  if (classesToRemove) {
    element.className = currentClasses
      .replace(regex, '')
      .replace(/\s+/g, ' ')
      .trim()
  }
}

/**
 * Apply subtitle custom settings as CSS classes to the player
 */
export const setSubtitleClasses = (
  player: TPlayer,
  textTrackCustomSettings: TextTrackCustomSettings
): void => {
  // Remove all existing subtitle-* classes
  removeClassesByRegex(player, /\bsubtitle-\S+/g)

  // Add new classes based on current settings
  player.addClass(
    `subtitle-font-family-${textTrackCustomSettings.fontFamily} 
    subtitle-font-color-${textTrackCustomSettings.fontColor} 
    subtitle-font-size-${textTrackCustomSettings.fontSize} 
    subtitle-font-opacity-${textTrackCustomSettings.fontOpacity} 
    subtitle-bg-color-${textTrackCustomSettings.backgroundColor} 
    subtitle-bg-opacity-${textTrackCustomSettings.backgroundOpacity} 
    subtitle-window-color-${textTrackCustomSettings.windowColor} 
    subtitle-window-opacity-${textTrackCustomSettings.windowOpacity} 
    subtitle-edge-style-${textTrackCustomSettings.characterEdgeStyle}`
  )
}
